import { render, staticRenderFns } from "./messageSurveyYesNo.vue?vue&type=template&id=454af6a6&"
import script from "./messageSurveyYesNo.vue?vue&type=script&lang=js&"
export * from "./messageSurveyYesNo.vue?vue&type=script&lang=js&"
import style0 from "./messageSurveyYesNo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports